import { render, staticRenderFns } from "./portSelector.vue?vue&type=template&id=2c43b81b&scoped=true&"
import script from "./portSelector.vue?vue&type=script&lang=js&"
export * from "./portSelector.vue?vue&type=script&lang=js&"
import style0 from "./portSelector.vue?vue&type=style&index=0&id=2c43b81b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c43b81b",
  null
  
)

export default component.exports